import * as types from './actionTypes'

export function beginApiCall() {
    return{
        type: types.BEGIN_API_CALL
    }
}

export function apiCallError() {
    return{
        type: types.API_CALL_ERROR
    }
}

export function zeroOutApiCall() {
    return{
        type: types.ZERO_OUT_API_CALLS
    }
}


// WEBPACK FOOTER //
// ./src/actions/apiStatusActions.js